import "./style.less";
import "antd/dist/reset.css";

import { ConfigProvider, notification } from "antd";
import enAnt from "antd/lib/locale/en_US";
import ruAnt from "antd/lib/locale/ru_RU";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import i18 from "i18next";
import * as React from "react";
import { RouterProvider } from "react-router-dom";

import { appStore } from "./appStore";
import { AuthChecker } from "./components/AuthChecker";
import { MsgQueue } from "./components/MsgQueue";
import { createMainRouter } from "./routes/MainRouter";
import { themeConfig } from "./themeConfig";

notification.config({ placement: "bottomRight" });

const antLocMap: Record<string, typeof ruAnt> = {
  ru: ruAnt,
  en: enAnt,
};
const antLocale = antLocMap[i18.language] || ruAnt;

dayjs.extend(utc);

const App: React.FC = () => {
  React.useEffect(() => {
    appStore.init();
  }, []);
  return (
    <ConfigProvider locale={antLocale} theme={themeConfig}>
      <AuthChecker>
        <RouterProvider router={createMainRouter()} />
      </AuthChecker>

      <MsgQueue />
    </ConfigProvider>
  );
};

export default App;
